import type { IBPCampaignDataFromServer } from "app/pages/digital-marketing/brand-monitoring-campaigns/wizard/BPCampaignsWizard.types";

export const getUpdatedCampaignItem = (
    indexOfItemToReplace: number,
    campaignsConfigurations: IBPCampaignDataFromServer[],
    newConfiguration: IBPCampaignDataFromServer,
) => {
    const currentConfigItem = campaignsConfigurations?.[indexOfItemToReplace];
    return {
        ...currentConfigItem,
        ...newConfiguration,
        createdTime: currentConfigItem?.createdTime,
    };
};

export const getUpdatedCampaignConfigurations = (
    indexOfItemToReplace: number,
    campaignsConfigurations: IBPCampaignDataFromServer[],
    updatedItem: IBPCampaignDataFromServer,
) => {
    const campaignsConfigurationsClone = [...campaignsConfigurations];
    campaignsConfigurationsClone?.splice(indexOfItemToReplace, 1, updatedItem);
    return campaignsConfigurationsClone;
};
